"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverMenu = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var popover_1 = require("../../hooks/popover");
var portal_1 = require("../../hooks/portal");
var box_1 = require("../box");
var icon_button_1 = require("../icon-button");
var padding_1 = require("../padding");
var popover_animation_1 = require("../popover-animation");
var tether_1 = require("../tether");
function PopoverMenu(props) {
    var _a;
    var options = props.options, children = props.children, type = props.type, color = props.color, label = props.label, disabled = props.disabled, tooltip = props.tooltip;
    var tetherOptions = {
        targetAnchor: ((options === null || options === void 0 ? void 0 : options.targetAnchor) || 'bottomLeft'),
        anchor: ((options === null || options === void 0 ? void 0 : options.anchor) || 'topLeft'),
        yOffset: (options === null || options === void 0 ? void 0 : options.yOffset) || 10,
        xOffset: (options === null || options === void 0 ? void 0 : options.xOffset) || undefined,
        width: (options === null || options === void 0 ? void 0 : options.width) || undefined,
        position: (_a = options === null || options === void 0 ? void 0 : options.position) !== null && _a !== void 0 ? _a : 'fixed',
    };
    var _b = (0, popover_1.usePopover)({
        excludeTarget: true,
    }), popoverRef = _b.popoverRef, isPopoverOpen = _b.isPopoverOpen, togglePopover = _b.togglePopover, targetRef = _b.targetRef;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(icon_button_1.IconButton, { type: type, color: color, onClick: togglePopover, innerRef: targetRef, ariaLabel: label, disabled: disabled, title: tooltip }),
        react_1.default.createElement(portal_1.Portal, { name: "popover" },
            react_1.default.createElement(tether_1.Tether, { targetRef: targetRef, targetAnchor: tetherOptions.targetAnchor, anchor: tetherOptions.anchor, yOffset: tetherOptions.yOffset, xOffset: tetherOptions.xOffset, width: tetherOptions.width, position: tetherOptions.position },
                react_1.default.createElement(popover_animation_1.PopoverAnimation, { isOpen: isPopoverOpen, direction: "up" },
                    react_1.default.createElement(box_1.Box, { backgroundColor: "white", border: 1, borderRadius: 3, elementRef: popoverRef, boxShadow: "overlay" },
                        react_1.default.createElement(padding_1.Padding, { y: 8 }, children(togglePopover))))))));
}
exports.PopoverMenu = PopoverMenu;
//# sourceMappingURL=index.js.map